import { OpcaoDeFatura, SugestaoDeFatura } from '../services/api';

/**
 * O pagamento de fatura na caixa do banco (13/10) — o lado da tela de
 * `backend/src/services/banco/pagamentoDeFatura.ts`.
 *
 * Puro, para a frase e a regra de "segura o Lançar" terem teste sem montar a
 * caixa inteira.
 */

/** 'AAAA-MM' → "outubro". Ao meio-dia, para o fuso não puxar o mês para trás. */
export const mesPorExtenso = (mes: string): string =>
  new Date(`${mes}-15T12:00:00`).toLocaleDateString('pt-BR', { month: 'long' });

/**
 * O movimento NÃO deve ser oferecido para lançar?
 *
 * O que o banco marcou como fatura e o que bate exato com uma fatura dela:
 * lançado, o cartão contaria duas vezes. A mesma regra do servidor, que nunca
 * lança esses sozinho.
 */
export const seguraOLancamento = (s: SugestaoDeFatura | null | undefined): boolean =>
  !!s && (s.marcada || s.opcoes.some(o => o.tipo === 'exata'));

/** A opção que o app sugere, quando há uma só. */
export const opcaoSugerida = (s: SugestaoDeFatura | null | undefined): OpcaoDeFatura | null =>
  (s && s.certeza === 'unica' ? s.opcoes[0] ?? null : null);

/** O que confirmar aquela opção significa, numa frase. */
export const consequenciaDe = (o: OpcaoDeFatura, fmt: (v: number) => string): string => {
  if (o.jaPaga) return 'Você já deu essa fatura como paga. Confirmar só tira este movimento da lista.';
  if (o.tipo === 'exata') return 'O valor é o da fatura: ela fica paga.';
  if (o.tipo === 'parcial') {
    return `Paga ${fmt(o.total - o.falta)} de ${fmt(o.total)}. Faltam ${fmt(o.falta)}, e a fatura segue em aberto.`;
  }
  return o.total > 0
    ? `São ${fmt(o.sobra)} a mais do que está lançado neste cartão. A fatura fica paga.`
    : 'Não há compra lançada neste cartão nesse mês. A fatura fica paga.';
};

/** Os meses entre os quais ela escolhe à mão: o do movimento, o anterior e o seguinte. */
export const mesesParaEscolher = (data: string): string[] => {
  const [a, m] = data.slice(0, 7).split('-').map(Number);
  return [-1, 0, 1].map(n => {
    const abs = a * 12 + (m - 1) + n;
    return `${Math.floor(abs / 12)}-${String((abs % 12) + 1).padStart(2, '0')}`;
  });
};
